import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './horizontal-buttons-item.component.scss';
var HorizontalButtonsItem = /** @class */ (function (_super) {
    tslib_1.__extends(HorizontalButtonsItem, _super);
    function HorizontalButtonsItem(element) {
        return _super.call(this, element) || this;
    }
    HorizontalButtonsItem.prototype.init = function () { };
    HorizontalButtonsItem.prototype.bindEvents = function () { };
    return HorizontalButtonsItem;
}(Base));
export { HorizontalButtonsItem };



//////////////////
// WEBPACK FOOTER
// ./components/horizontal-buttons-item/horizontal-buttons-item.component.ts
// module id = 361
// module chunks = 0